import { FC } from "react";
import { Box, VStack, Heading, Text, Button } from "@chakra-ui/react";
import Link from "next/link";
import Image from "next/image";
import { Locale } from "@/constants/landingPages";

interface PlatformIntegrationProps {
  id: string;
  locale: Locale;
  content: {
    name: string;
    description: string;
    ctaText: string;
  };
}

export const PlatformIntegration: FC<PlatformIntegrationProps> = ({
  id,
  locale,
  content,
}) => (
  <Link href={`/${locale}/${id}`} passHref legacyBehavior>
    <Box
      as="a"
      p="8"
      bg="white"
      borderRadius="xl"
      borderWidth="2px"
      borderColor="gray.200"
      boxShadow="sm"
      transition="all 0.3s"
      cursor="pointer"
      _hover={{
        borderColor: "blue.500",
        boxShadow: "lg",
        transform: "translateY(-4px)",
      }}
      display="flex"
      flexDirection="column"
      height="full"
    >
      <VStack align="stretch" spacing="3" flex="1">
        {/* Platform Logo */}
        <Box
          textAlign="center"
          display="flex"
          alignItems="center"
          justifyContent="center"
          minHeight="100px"
        >
          <Image
            src={`/assets/${id}.svg`}
            alt={`${content.name} logo`}
            width={200}
            height={100}
            style={{ objectFit: "contain" }}
          />
        </Box>

        {/* Platform Name - Hidden visually but available for SEO/screen readers */}
        <Heading
          as="h3"
          fontSize="2xl"
          fontWeight="semibold"
          color="gray.900"
          textAlign="center"
          srOnly
        >
          {content.name}
        </Heading>

        {/* Description */}
        <Text
          fontSize="md"
          color="gray.600"
          textAlign="center"
          lineHeight="tall"
          flex="1"
        >
          {content.description}
        </Text>

        {/* CTA Button */}
        <Button colorScheme="blue" size="lg" width="full" mt="4">
          {content.ctaText}
        </Button>
      </VStack>
    </Box>
  </Link>
);
